// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3_bDn","title":"Info_title__3TAKj","selects":"Info_selects__SDsFg","requiredAsterisk":"Info_requiredAsterisk__4DlxS"};